import { Client } from 'api/client/types';

export function isIndividualClient(client: Client) {
  return !!client.clientUser?.email && !client.company;
}

export function isLegalClient(client: Client) {
  return client.company?.name;
}
